const InputValidation = require("./InputValidation");
const RaceRotator = require("./RaceRotator");
const TieHandler = require("./TieHandler");
const RaceTracker = require("./RaceTracker");
const RuleLogic = require("./RuleLogic");
const CourseGen = require("./CourseGen");
const GameplayDraft = require("./GameplayDraft");
const metadata = require("./metadata");
const formatting = require("./formatting");

exports.InputValidation = InputValidation;
exports.RaceRotator = RaceRotator;
exports.TieHandler = TieHandler;
exports.RaceTracker = RaceTracker;
exports.RuleLogic = RuleLogic;
exports.CourseGen = CourseGen;
exports.metadata = metadata;
exports.normalizeDraftPlayer = GameplayDraft.normalizeDraftPlayer;
exports.createGameplayDraft = GameplayDraft.createGameplayDraft;
exports.isGameplayDraftV1 = GameplayDraft.isGameplayDraftV1;
exports.getAuthoritativeRaceCount = GameplayDraft.getAuthoritativeRaceCount;
exports.shouldEvaluateTieBreak = GameplayDraft.shouldEvaluateTieBreak;
exports.deriveScoreHistory = GameplayDraft.deriveScoreHistory;
exports.applyCharactersToRoster = GameplayDraft.applyCharactersToRoster;
exports.isCompleteHeat = GameplayDraft.isCompleteHeat;
exports.resolveLineupPlayer = GameplayDraft.resolveLineupPlayer;
exports.resolveLineupPlayers = GameplayDraft.resolveLineupPlayers;
exports.roundToNearestMinute = formatting.roundToNearestMinute;
exports.validateRacePlayerInput = InputValidation.validateRacePlayerInput;
exports.validateRaceInput = InputValidation.validateRaceInput;
exports.validateFullRaceInput = InputValidation.validateFullRaceInput;
exports.validateGrandPrixInput = InputValidation.validateGrandPrixInput;
exports.validateStaticRaceInput = InputValidation.validateStaticRaceInput;
exports.getWinsWinners = TieHandler.getWinsWinners;
exports.getScoreWinners = TieHandler.getScoreWinners;
exports.isTie = TieHandler.isTie;
exports.updateScores = RaceTracker.updateScores;
exports.getPlaceKey = RaceTracker.getPlaceKey;
exports.getScoreIncrement = RaceTracker.getScoreIncrement;
exports.getRuleParameter = RaceTracker.getRuleParameter;
exports.initHistory = RaceTracker.initHistory;
exports.getRule = RuleLogic.getRule;
exports.getAllowedGroupSizes = RuleLogic.getAllowedGroupSizes;
exports.getMapList = CourseGen.getMapList;
exports.rotateRacers = RaceRotator.rotateRacers;
exports.parseAndSortTable = require("./StatsFormatting").parseAndSortTable;
exports.assertVersion = function assertVersion(expected, actual) {
  if (expected !== actual) throw new Error(`Session version conflict: expected ${expected}, received ${actual}`);
};
